import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { logger } from 'services';
import { floatUid } from 'utils/uid';
import {
  CreateSubTaskInProjectTemplate,
  createSubTaskInProjectTemplate,
} from '../actions';
import {
  createProjectTemplateSubTask,
  setProjectTemplateActiveRecord,
} from '../slices';

function* createSubTaskInTemplateSaga(
  action: StoreActionProps<CreateSubTaskInProjectTemplate>,
) {
  try {
    const { payload } = action;
    const { payload: newTaskPayload = {} } = payload;
    const task = {
      taskId: floatUid(),
      ...newTaskPayload,
      isNew: true,
    };

    yield put(
      createProjectTemplateSubTask({
        task,
        parentTaskId: payload.parentTaskId,
      }),
    );

    yield put(
      setProjectTemplateActiveRecord({
        id: payload.parentTaskId,
        type: 'TASK',
      }),
    );
  } catch (error) {
    logger.error('an error creating a sub task in the template', { error });

    message.error('There was an error creating a sub task in the template');
  }
}

export function* watchCreateSubTaskInTemplateSagaSaga(): Generator {
  yield takeLatest(
    createSubTaskInProjectTemplate.type,
    createSubTaskInTemplateSaga,
  );
}
